if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}

"use strict"

var UTI = (typeof UTI === 'object') ? UTI : {};
UTI.isdesktop = true;

UTI.common = {

  init: function () {
    var _this = this;

    $('video.click-play').click(function(e){
      $(this).toggleClass("play");
      $(this).parent().toggleClass("playdiv");
      if($(this).hasClass("play"))
      {
        $(this).get(0).play();
      }
      else
      {
        $(this).get(0).pause();
      }
    });


  }
};

$(function () {
  UTI.common.init();
  PROJ.ajaxcart.init();
  PROJ.upsells.init();
});

var PROJ = (typeof PROJ === 'object') ? PROJ : {};

PROJ.upsells = {
  VAR: {},

  init: function () {
    var _this = this;

    $('body').on('click', '.close-upsell, .upsell-overlay', function (e) {
      e.preventDefault();
      _this.closecart();
      PROJ.ajaxcart.opencart();
    });

    $('body').on('click', '.con-shopping', function (e) {
      e.preventDefault();
      _this.closecart();
    });

    $('body').on('click', '.upsell-to-checkout', function (e) {
      e.preventDefault();
      _this.closecart();
      PROJ.ajaxcart.opencart();
    });

    $('body').on('click', '[data-qcvarid]', function (e) {
      e.preventDefault();
      var varid = $(this).attr('data-qcvarid');

      $(this).parents('.forcart').find('[data-qcvarid]').removeClass('active');
      $(this).addClass('active');

      if($(this).hasClass('nostock'))
      {
        $('.quick-buy-popup .quick-buy > a').text('Sold Out');
        $(this).parents('.forcart').find('.quick-buy a').removeAttr('data-directadd');
      }else
      {
        $('.quick-buy-popup .quick-buy > a').text('Add to bag');
        $(this).parents('.forcart').find('.quick-buy a').attr('data-directadd',varid);
      }
    });

    $('body').on('click', '.first-op .selector-wrapper.se-1 > div', function (e) {
      e.preventDefault();
      $('.selector-wrapper.se-1 > div').removeClass('active');
      $(this).addClass('active');
      var opname = $(this).attr('data-opname');
      $('.var-sets [data-opname]').hide();
      $('.var-sets [data-opname="'+opname+'"]').show();

      $('.var-sets [data-opname="'+opname+'"]').each(function() {
        $(this).click();
        return false;
      });

    });

    var upsellid = "";

    $('body').on('click', '.upsell-replace', function (e) {

      e.preventDefault();
      e.stopPropagation();
      $('#shopify-section-upsells .ajax_loader').addClass('active');
      var productid = $('[data-product-select]').attr('data-product-select');
      if(upsellid == "")
      {
        upsellid = $('[data-upsell-id]').attr('data-upsell-id');
      }

      var datas = "updates[" + productid + "]=" + 0 + "&";
      datas += "updates[" +upsellid+ "]=" + 1 + "&";

      // Add to cart.
      jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: datas,
        dataType: 'json',
        success: function () {
          PROJ.ajaxcart.updateCart();
          $('#shopify-section-upsells .ajax_loader').removeClass('active');
          $('body,html').removeClass('upsell-cart-ani');
          $('body,html').addClass('mini-cart');
          setTimeout(function(){
            $('body,html').addClass('mini-cart-ani');
            $('body,html').removeClass('upsell-cart');

          },500);
        }
      });

    });

  },

  productAdded:function(data)
  {
    this.opencart();
  },productSingleUpsell:function(data)
  {

    // $('#upsell-ajax').html('<div class="quick-buy-popup"><img class = "loader" src="'+loadergif+'"> </div>');
    if(wholesalecus) location.replace('/cart');
    $('#shopify-section-upsells').animate({
      scrollTop: 0}, 10);

    $.get("/cart?view=upsell", function (data) {
      $('#upsell-ajax').html(data);
    }).done(function (cart) {
      $('body,html').addClass('upsell-cart');
      $('.scroll-wrap').animate({ scrollTop: 0 }, 'slow');
      $('#shopify-section-upsells .ajax_loader').removeClass('active');

      var allcarids = $('.cart-b-wrap').attr('data-cart-ids');
      $('.upsell-pr').each(function(){
        var ids = $(this).find('[data-directadd]').attr('data-directadd');
        if(allcarids.includes(ids))
        {
          $(this).addClass('incart');
        }else
        {
          $(this).removeClass('incart');
        }
      });

      $('.offer-item-name').text($('[data-upcol-title]').attr('data-upcol-title'));

    });

    $('[data-up-img][src=""]').each(function(){
      $(this).attr('src',$(this).attr('data-up-img'));
    });

  },

  opencart: function () {
    // $('#upsell-ajax').html('<div class="quick-buy-popup"><img class = "loader" src="'+loadergif+'"> </div>');
    if(wholesalecus) location.replace('/cart');
    $('#shopify-section-upsells').animate({
      scrollTop: 0}, 10);

    $.get("/cart?view=upsell", function (data) {
      $('#upsell-ajax').html(data);
    }).done(function (cart) {
      $('body,html').addClass('upsell-cart');
      $('.scroll-wrap').animate({ scrollTop: 0 }, 'slow');
      $('#shopify-section-upsells .ajax_loader').removeClass('active');
      setTimeout(function(){
      var allcarids = $('.cart-b-wrap').attr('data-cart-ids');
      var  dislimitarr = dislimit.split('|');
      var  disdiscountarr = disdiscount.split('|');

      $('.upsell-pr').each(function(){
        var ids = $(this).find('[data-directadd]').attr('data-directadd');
        if(allcarids.includes(ids))
        {
          $(this).addClass('incart');
        }else
        {
          $(this).removeClass('incart');
        }
        var newdiscount = 0;
        var newdiscounttotla = 0;
        $(this).find('.pr-label').html("");
        var totalwiththis = parseInt($(this).attr('data-lable-price')) + parseInt($('[data-orginal-price]').attr('data-orginal-price')) ;
        for (var l = 0; l < dislimitarr.length; l++) {
          if((parseInt(dislimitarr[l])*100) < totalwiththis )
          {
            newdiscounttotla = (totalwiththis*(100 - parseInt(disdiscountarr[l])))/100;
            newdiscount = disdiscountarr[l];
          }
        }
        if( newdiscounttotla >= freeshipping )
        {
          $(this).find('.pr-label').html("<span class='freeship'>Freeshipping + </span>" + newdiscount + "% off");
        }else
        {
          $(this).find('.pr-label').html(newdiscount + "% off");
        }
        if(newdiscount == 0) $(this).find('.pr-label').hide();

      });
      },1000);
      /*
      $('.changeing-text h3').hide();
      var discount_items = parseInt($('.cart-b-wrap').attr('data-discounted-items'));
      var free_th = parseInt($('.cart-b-wrap').attr('data-free-th'));
      var totalp = parseInt($('.cart-b-wrap').attr('data-total-price'));
      if(totalp < free_th)
      {
        $('.changeing-text h3').eq(0).show();
      }else if(discount_items == 2)
      {
        $('.changeing-text h3').eq(1).show();
      }else if(discount_items == 3)
      {
        $('.changeing-text h3').eq(2).show();
      }else if(discount_items == 4)
      {
        $('.changeing-text h3').eq(3).show();
      }*/

      $('.offer-item-name').text($('[data-upcol-title]').attr('data-upcol-title'));
    });

    $('[data-up-img][src=""]').each(function(){
      $(this).attr('src',$(this).attr('data-up-img'));
    });


  },
  closecart: function () {
    $('body,html').removeClass('upsell-cart');
    $('body,html').removeClass('upsell-cart-ani');
  }

};


var PROJ = (typeof PROJ === 'object') ? PROJ : {};


PROJ.ajaxcart = {
  VAR: {},

  init: function () {
    var _this = this;
    // _this.updateCart();
    _this.giftwrap();


    $('body').on('click', '.cart-name .nav-close-cart', function (e) {
      e.preventDefault();
      _this.closecart();
    });


    $('body').on('change', '.upsell-item .quantity-input', function (e) {
      e.preventDefault();
      _this.updateItem( $(this).parents('.incart').attr('data-proid'),  $(this).val());
    });

    $('body').on('click', '[data-remove-upsell]', function (e) {
      e.preventDefault();
      var varid = $(this).attr('data-remove-upsell');
      _this.updateItem( varid,  0);
    });

    $('body').on('click tap', '.upsell-item .minus-control, .upsell-item .plus-control', function (e) {
      $(this).parents('.upsell-item').find('input').trigger('change');
    });

    $('body').on('click tap', 'a[href="/cart"], .cart-open', function (e) {
      e.preventDefault();
      _this.opencart();
      // PROJ.upsells.opencart();
    });

    $('body').on('click', '[data-varid]', function (e) {
      e.preventDefault();
      var varid = $(this).attr('data-varid');
      $(this).parents('.cross-slide').find('.quick-buy a').attr('data-directadd',varid);
      $(this).parents('.cross-slide').find('[data-varid]').removeClass('active');
      $(this).addClass('active');
    });


    //activate free gift with chkecnbox

    $('body').on('change', '#fgifts', function (e) {
      if(this.checked) {
        $('.free-items-box .dum').hide();
        $('.free-items-box .org').show();
      }else
      {
        $('.free-items-box .dum').show();
        $('.free-items-box .org').hide();
      }
    });


    $('body').on('click', '[data-directadd]', function (e) {
      e.preventDefault();
      _this.addItem($(this).attr('data-directadd'));
    });

    $('body').on('click', '.qty-step-btn', function (e) {
      e.preventDefault();
      var par = $(this).parents('.incart');
      var qty = par.attr('data-count');
      if ($(this).find('.icon-minus').length) {
        qty--;
        if (qty < 0) qty = 0;
      }
      else {
        qty++;
      }
      par.attr('data-count',qty);
      par.find('.qty-step-count').text(qty);
      _this.updateItem(par.attr('data-proid'), qty);

      setTimeout(function(){
        if($('body').hasClass('template-cart'))
        {
          location.reload(true);
        }
      },500);


    });

    $('body').on('click', '.incart .remove', function (e) {
      e.preventDefault();
      var par = $(this).parents('.incart');
      var qty = 0;
      _this.updateItem(par.attr('data-proid'), qty);
    });


    // removing upsell
    $('body').on('click', '.remove.removeupsell', function (e) {
      e.preventDefault();
      $('#mini-cart').addClass("hide-upsell");
      jQuery.cookie("hideupsells","true");
    });

    $('body').on('click', '.show-upsell', function (e) {
      e.preventDefault();
      $('#mini-cart').removeClass("hide-upsell");
      jQuery.cookie("hideupsells","false");
    });


    $('body').on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      if(upsellcollection || upsellproduct)
      {
        $('body,html').addClass('upsell-cart-ani');
      }else
      {

      }
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function (product) {
          _this.updateCart();
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          if(upsellproduct)
          {
            PROJ.upsells.productSingleUpsell(product);
          }else if(upsellcollection)
          {
            PROJ.upsells.productAdded(product);
          }else
          {
            setTimeout(function(){
              _this.opencart();
            },1200);
          }
          window.setTimeout(function () {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
        },
        error: function (XMLHttpRequest) {
          _this.updateCart();

        }
      });
      return false;

    });

    // $('form[action="/cart/add"]').on('submit', (function (e) {
      $('body').on('submit', 'form[action="/cart/add"]', function (e) {

      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartBtn = $('.cart-btn button');
      $('#mini-cart').addClass('loading');

      $addToCartBtn.addClass('disabled').prop('disabled', true);
      _this.opencart();
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        type: 'post',
        data: $addToCartForm.serialize(),
        success: function (itemData) {
          $addToCartBtn.removeClass('disabled').prop('disabled', false);
          _this.updateCart();
        },
        error: function (XMLHttpRequest) {
          _this.updateCart();

        }
      });
      return false;

    });

    $(window).resize(function () {

      _this.resizecart();
    });
    $(window).resize(function () {
      PROJ.ajaxcart.resizecart();
    });
    setTimeout(function(){
      PROJ.ajaxcart.resizecart();
    },1000);




  },resizecart:function(){
    var maxh = $(window).height()-80;
    $('.ajax_place').css('max-height',maxh+"px");
    $('.mini-body').height($('#shopify-section-mini-cart').height() - $('.checkout-se').height() - 40);
    //$('#mini-cart .mini-body').css('max-height',$(window).height() - ($('.checkout-se').height() + 70 + $('.sell-note').height()));
  },

  updateCart: function () {
    var _this = this;
    $('body,html').removeClass('mini-cart-ani');
    $.get("/cart?view=mini", function (data) {

      $('#mini-cart .ajax_place').html($(data));
      var counti = parseInt($('[data-icount]').attr('data-icount'));
      $('.header-cart__count').text(counti);
      if(counti===0)
      {
        $('.header-cart').removeClass('has-cart-count');
      }else
      {
        $('.header-cart').addClass('has-cart-count');
      }

    }).done(function (cart) {

      $('#mini-cart').removeClass('loading');
      PROJ.ajaxcart.resizecart();
      if($('#mini-cart [data-limit]').length)
      {
        $('#mini-cart [data-limit]').each(function(){
          var limit = parseInt($(this).attr('data-limit'));
          if(parseInt($(this).attr('data-count'))>limit)
          {
            _this.updateItem($(this).attr('data-proid'), limit);
          }

        });
      }

      $('body,html').addClass('mini-cart-ani');

    });
  },

  addItem: function (id) {
    var _this = this;

    if(!$('body').hasClass('upsell-cart'))
    {
      $('#mini-cart').addClass('loading');
      $('body,html').addClass('mini-cart');
    }else
    {
      $('#shopify-section-upsells .ajax_loader').addClass('active');
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=" + 1 + "&id=" + id,
      dataType: "json",
      success: function (t) {
        if(!$('body').hasClass('upsell-cart'))
        {
          _this.updateCart();
        }else
        {
          PROJ.upsells.opencart();
          _this.updateCart();
        }

      },
      error: function (t, r) {
        _this.updateCart();
      }
    });
  },

  updateItem: function (id, le) {
    var _this = this;
    $('#mini-cart').addClass('loading');

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + le + "&id=" + id,
      dataType: "json",
      success: function (t) {
        Shopify.getCart(function(cart){
          _this.updateCart();
          if($('body').hasClass('upsell-cart'))
          {
            PROJ.upsells.opencart();
          }
        }.bind(this));
      },
      error: function (t, r) {
        _this.updateCart();
      }
    });
  },

  giftwrap: function () {
    var _this = this;
    $('body').on('keyup','#gift-note', function (e) {
      var count = $(this).val().length;
      var max = $(this).attr('maxlength');
      $(this).next().html("<strong>"+(max - count) +"</strong>"+ " Characters Remaining");
    });

    $('body').on('click','.gift-wrap-panel .all-close-cart, .gift-wrap-panel .nav-close-cart', function (e) {
      $('.gift-wrap-panel ').removeClass('active');
    });
    $('body').on('click','.gift-title.propose', function (e) {
      if($('.gift-wrap-wrap').hasClass('activegift'))
      {
        var gid = $('[data-gift-id]').attr('data-gift-id');
        $('#mini-cart').addClass('loading');
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: "updates["+gid+"]=0&attributes[gift-note]="+encodeURIComponent(''),
          dataType: "json",
          success: function (t) {
            _this.updateCart();
          },
          error: function (t, r) {
            _this.updateCart();
          }
        });
      }else
      {
        $('.gift-wrap-panel ').addClass('active');
      }
    });
    $('body').on('click','.gift-wrap-box .edit', function (e) {
      $('.gift-wrap-panel ').addClass('active');
    });
    $('body').on('click','[data-gift-id]', function (e) {
      e.preventDefault();
      var gid = $(this).attr('data-gift-id');
      $('#mini-cart').addClass('loading');
      if($('.gift-wrap-wrap').hasClass('activegift'))
      {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: "attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
          dataType: "json",
          success: function (t) {
            _this.updateCart();
          },
          error: function (t, r) {
            _this.updateCart();
          }
        });
      }else
      {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: "updates["+gid+"]=1&attributes[gift-note]="+encodeURIComponent($('#gift-note').val()),
          dataType: "json",
          success: function (t) {
            _this.updateCart();
          },
          error: function (t, r) {
            _this.updateCart();
          }
        });
      }

    });


  },

  opencart: function () {
    if(wholesalecus) location.replace('/cart');
    $('body,html').addClass('mini-cart');
    setTimeout(function(){
      $('body,html').addClass('mini-cart-ani');
    },500);
  },
  closecart: function () {
    $('body,html').removeClass('mini-cart');
    setTimeout(function(){
      $('body,html').removeClass('mini-cart-ani');
    },500);
  }


};
